/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Shadow = styled.img.attrs({ src: t.image.shadow })`
  ${t.mixins.sm(`
    max-width: 346px;
    height: 15px;
  `)}
`;

/**
 * separator component is..
 */

const Shadow__separator = () => <Shadow />;

export default Shadow__separator;

Shadow__separator.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Shadow__separator.defaultProps = {
  style: {},
};

/*
    import Shadow__separator from 'components/shadow/separator/shadow__separator'
    <Shadow__separator />
  */
